import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { IEmployeeSummaryInfo } from 'app/shared/model/employee-summary-info.model';
import { IEmployeeTypes } from 'app/shared/model/employee-types.model';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  protected resourceUrl = '/hrm-portal-api/api/employees/';

  constructor(
    public http: HttpClient,
    private _fuseProgressBarService: FuseProgressBarService
  ) {}

  getSummaryInfo(): Observable<any> {
    return this.http.get<IEmployeeSummaryInfo>(`${this.resourceUrl}summary-info`);
  }

  getEmployeeTypes(): Observable<any> {
    return this.http.get<IEmployeeTypes>(`${this.resourceUrl}types`)
  }
}
